import Chip from "components/Chip";
import DisclosureCard from "components/DisclosureCard";
import GridDetailsLayout from "components/GridDetailsLayout";

const SecondCardSx = ({ state }) => {
    let showFqdnCluster = false;
    let fqdnMaster, fqdnBackup;
    state.data.licenses.map((license) => {
        if (license.active && license.code === "cluster") {
            if (state?.data?.fqdn) {
                const fqdnParts = state.data.fqdn.split(".");
                if (fqdnParts.length === 3) {
                    showFqdnCluster = true;
                    fqdnMaster = `${fqdnParts[0]}001.${fqdnParts[1]}.${fqdnParts[2]}`;
                    fqdnBackup = `${fqdnParts[0]}002.${fqdnParts[1]}.${fqdnParts[2]}`;
                }
            }
        }
    });

    let reduced;
    if (state?.data?.mac_addresses) {
        reduced = Object.keys(state?.data?.mac_addresses).reduce(
            (acc, current) => {
                let val = state.data.mac_addresses[current];
                if (val && val !== "") {
                    return acc + "\n\r" + current + ": " + val;
                } else {
                    return acc;
                }
            },
            ""
        );
    }
    let reducedBackup;
    if (state?.data?.mac_addresses_backup) {
        reducedBackup = Object.keys(state.data.mac_addresses_backup).reduce(
            (acc, current) => {
                let val = state.data.mac_addresses_backup[current];
                if (val && val !== "") {
                    return acc + "\n\r" + current + ": " + val;
                } else {
                    return acc;
                }
            },
            ""
        );
    }
    return (
        <DisclosureCard
            extra={"w-full p-4 sm:overflow-x-auto"}
            button={() => (
                <div className="relative mb-6 flex items-center justify-between">
                    <div className="flex">
                        <div className="text-2xl font-bold text-gray-800 dark:text-white">
                            Dati server
                        </div>
                    </div>
                    <div>
                        <img
                            src="/icon/chevron-down.svg"
                            alt="Dati server"
                            className="text-[26px] font-bold uppercase text-navy-700 dark:text-white"
                        />
                    </div>
                </div>
            )}
            content={() => (
                <GridDetailsLayout
                    dataConfig={[
                        {
                            key: "FQDN",
                            value: state.data.fqdn,
                        },
                        ...(showFqdnCluster
                            ? [
                                  {
                                      key: "FQDN master",
                                      value: fqdnMaster,
                                  },
                              ]
                            : []),
                        ...(showFqdnCluster
                            ? [
                                  {
                                      key: "FQDN backup",
                                      value: fqdnBackup,
                                  },
                              ]
                            : []),
                        {
                            key: "IP",
                            value: state.data.ip_fqdn,
                        },
                        {
                            key: "IP server backup",
                            value: state.data.ip_server_backup,
                        },
                        {
                            key: "Dimensione server",
                            value: state.data.size,
                        },
                        {
                            key: "Codice server",
                            value: state.data.server_code,
                        },
                        {
                            key: "Codice server backup",
                            value: state.data.server_code_backup,
                        },
                        {
                            key: "Mac Addresses",
                            value: (
                                <div className="ml-1 flex flex-wrap gap-2">
                                    {reduced
                                        ?.match(/eth\d+:\s[a-f0-9:]+/gi)
                                        ?.map(
                                            (mac) =>
                                                mac && (
                                                    <Chip
                                                        key={mac}
                                                        text={mac}
                                                    />
                                                )
                                        )}
                                </div>
                            ),
                        },
                        ...(reducedBackup
                            ? [
                                  {
                                      key: "Mac Addresses backup",
                                      value: (
                                          <div className="ml-1 flex flex-wrap gap-2">
                                              {reducedBackup
                                                  ?.match(
                                                      /eth\d+:\s[a-f0-9:]+/gi
                                                  )
                                                  ?.map(
                                                      (mac) =>
                                                          mac && (
                                                              <Chip
                                                                  key={mac}
                                                                  text={mac}
                                                              />
                                                          )
                                                  )}
                                          </div>
                                      ),
                                  },
                              ]
                            : []),
                    ]}
                />
            )}
        />
    );
};

export default SecondCardSx;
